<!-- eslint-disable no-plusplus -->
<!--
  V 0.3.0 - 2024-04-30
    - Chanced the calendar to use stacked mode with 0 overlap

  V 0.2.5 - 2023-03-28
    - moved from codesandbox after making more mobile friendly/

  V 0.2.4 - 2023-03-22
    - also modified RegNumber to VehicleReg
    - made defualt last 4 days
    - removed back button
    -

 v 0.2.0 -  2023-03-22
    -

 V 0.1.0 - 2022-07-12
    - Removed from mobile app for purposes of adding ore alloinw

 -->
<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar flat>
          <div class="text-h5">{{ VehicleReg }}</div>

          <v-divider class="mx-4" vertical></v-divider>

          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon> mdi-chevron-left </v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon> mdi-chevron-right </v-icon>
          </v-btn>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn fab
                     small
                     v-bind="attrs"
                     v-on="on"
                     outlined
                     class="mr-4"
                     color="grey darken-2"
                     @click="setToday">
                <v-icon> mdi-page-last</v-icon>
              </v-btn>
            </template>
            <span>Today</span>
          </v-tooltip>

          <v-divider class="mx-4" vertical></v-divider>

          <v-toolbar-title v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>

          <v-spacer></v-spacer>
          <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right> mdi-menu-down </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Day</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Week</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Month</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = '4day'">
                <v-list-item-title>4 days</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>

      <v-progress-linear v-if="isLoading"
                         indeterminate
                         color="blue"></v-progress-linear>

      <v-sheet height="1800">
        <!--
           ------------------------------------------------------------

        -->
        <v-calendar ref="calendar"
                    v-model="selectedDateModel"
                    color="primary"
                    :events="events"
                    :event-color="getEventColor"
                    :type="type"
                    @click:event="showEvent"
                    @click:more="viewDay"
                    @click:date="plotDayAll"
                    @change="updateRange"
                    event-overlap-mode="column"
                    event-overlap-threshold="-1">
        </v-calendar>

        <v-menu v-model="selectedOpen"
                :close-on-content-click="false"
                :activator="selectedElement"
                offset-x>
          <v-card color="grey lighten-4" flat>
            <v-toolbar :color="selectedEvent.color" dark>
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
              <v-spacer></v-spacer>
              <!--
              Get button working later.
                          -->
              <v-btn icon
                     :to="`/trip-plot/${selectedEvent.Id}/${UnitID}/${VehicleReg}/calendar-trips-select/${selectedEvent.dayDate}/${VehicleID}`">
                <v-icon>mdi-arrow-left-right</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text>
              <v-list-item-avatar>
                <v-icon>mdi-arrow-left-right</v-icon>
              </v-list-item-avatar>

              <span v-html="selectedEvent.details"></span>
              <span v-html="selectedEvent.description"></span>
            </v-card-text>

            <v-card-actions>
              <v-btn text color="secondary" @click="selectedOpen = false">
                Cancel
              </v-btn>
              <!--   :to="`/trip-plot/${selectedEvent.Id}/${UnitID}/${VehicleReg}/calendar-trips-select/${selectedEvent.dayDate}/${VehicleID}`" -->
              <v-btn text
                     color="secondary"
                     @click="plotTrip(selectedEvent)" >
                Show Trip
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
  </v-row>
</template>
<script>
/* eslint-disable no-plusplus */
/* eslint-disable no-return-assign */
/* eslint-disable no-var */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
/* eslint-disable eqeqeq */

import { format, parseISO, addDays } from 'date-fns'

export default {
  data: () => ({
    VehicleReg: 'None',
    UnitID: '',
    Driver: 'None',
    day: '',
    //
    picker3: format(
      parseISO(addDays(new Date(), -1100).toISOString()),
      'yyyy-MM-dd'
    ),

    datePick: new Date(),

    dayDateSet: false,
    dateSetFromParam: false,
    //
    UnitModelId: 0,
    //
    VehicleID: -1,
    //
    dayDate: '',
    //
    isLoading: false,
    //
    earliestTime: '05:00',

    // [s ]
    selectedDateModel: new Date(),
    type: '4day',
    typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      '4day': '4 Days'
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: []
  }),

  mounted () {
    if (this.$debug) {
      console.log('mounted:')
    }
  },

  created () {
    if (typeof this.$route.params.dayDate !== 'undefined') {
      this.pathDateParam = this.$route.params.dayDate

      const pathDate = new Date(this.pathDateParam)

      this.earliestTime = this.formatDate(pathDate)
      this.selectedDateModel = pathDate
    }
    else {
      const today = new Date()
      this.selectedDateModel = today
      this.pathDateParam = this.dayDateFormat(today)
    }

    if (typeof this.$route.params.VehicleReg !== 'undefined') {
      this.VehicleReg = this.$route.params.VehicleReg
    }

    if (typeof this.$route.params.UnitID !== 'undefined') {
      this.UnitID = this.$route.params.UnitID
    }
  }, // created()

  methods: {
    formatDate (date) {
      const year = date.getFullYear()
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const day = ('0' + date.getDate()).slice(-2)
      return year + '-' + month + '-' + day
    },

    formatTime (date) {
      if (date == null || date == undefined) {
        return '00:00'
      }
      const hours = ('0' + date.getHours()).slice(-2)
      const minutes = ('0' + date.getMinutes()).slice(-2)
      var time = hours + ':' + minutes
      return time
    },

    dayDateFormat (time) {
      return format(new Date(time), 'yyyy-MM-dd')
    },

    plotTrip (selectedEvent) {
      console.log('plotTrip')
      //
      //  `/trip-plot/${selectedEvent.Id}/${UnitID}/${VehicleReg}/calendar-trips-select/${selectedEvent.dayDate}/${VehicleID}`
      const route =
          '/trip-plot' +
          `/${selectedEvent.Id}` +
          `/${this.UnitID}` +
          `/${this.VehicleReg}` +
          '/calendar-trips-select' +
          `/${selectedEvent.dayDate}` +
          `/${this.VehicleID}`

      this.$router.push(route)
    },
    /*
        V 0.2.0 - 2026-01-27
           - removed old method of plotting whole day because it used
             embeded encoded icons, and made the application big

        V 0.1.0 - 2024-05-07

      */
    plotDayAll ({ date }) {
      console.log('plotDayAll')
      //     path: "/trip-plot-all/:UnitID/:VehicleReg/:previousPage/:dayDate/:VehicleID",
      //  day-trip-navigator/352625690439854/FN23VLGP/day-navigator/2026-01-19/undefined
      const route =
          '/day-trip-navigator' +
          `/${this.$route.params.UnitID}` +
          `/${this.$route.params.VehicleReg}/calendar-trips-select` +
          `/${date}` +
          `/${this.$route.params.VehicleID}`

      this.$router.push(route)
    },

    viewDay ({ date }) {
      this.selectedDateModel = date
      this.type = 'day'
    },

    getEventColor (event) {
      return event.color
    },
    setToday () {
      this.selectedDateModel = ''
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },

    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        )
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },

    updateRange ({ start, end }) {
      if (this.$debug) {
        console.log('updateRange: start - end')
        console.log(start)
        console.log(end)
        console.log('params:')
        console.log(this.$route.params)
      }

      this.UnitID = this.$route.params.UnitID

      this.getTrips(start, end).then(() => {
        if (this.$debug) {
          console.log(`scrollToTime: ${this.earliestTime}`)
        }
        this.$refs.calendar.scrollToTime(this.earliestTime)
      })
    },

    /// ----------------------------------------------------------------------
    ///
    /// ----------------------------------------------------------------------
    getTrips (start, end) {
      this.isLoading = true

      let url = `${this.$baseUrl}/api/v2/trip/between`

      url += `?UnitID=${this.UnitID}`
      url += `&Start=${start.date}`
      url += `&End=${end.date}`

      if (this.$debug) {
        console.log(url)
      }

      return this.$axiosCache
        .get(url)
        .then((res) => {
          if (this.$debug) {
            console.log(res)
          }
          this.isLoading = false
          const alarms = res.data
          this.events = this.updateTrips(alarms, start, end)
          console.log(this.events)
        })
        .catch((err) => {
          console.log('updateRange')
          console.log(err)
          this.isLoading = false
        })
    },

    /**
       *
       *    V0.2.0 - 2023-03-27
       *       - ADded the search for the earliest time
       *
       *    V 0.1.0 - 2023-02-16
       *       - Modified dealing with Dates
       *
       */
    updateTrips (trips, start, end) {
      try {
        // debugger;
        const events = []
        const eventCount = trips.length

        const min = new Date(`${start.date}T00:00:00`)
        const max = new Date(`${end.date}T23:59:59`)

        this.earliestTime = '24:00'

        var first = true

        for (let i = 0; i < eventCount; i++) {
          try {
            var trip = trips[i]
            var desc = ''

            var eventColor
            var violationCount = 0

            var str = trip.StartTime.split('T')[1].split('.')[0]

            const startDate = new Date(trip.StartTime)
            const currTime = this.formatTime(startDate)

            if (currTime < this.earliestTime) {
              this.earliestTime = currTime
              if (this.$debug) {
                console.log(`update: ${this.earliestTime}`)
              }
            }

            if (trip.Violation02Count > 0) {
              desc += `Harsh Brake:  ${trip.Violation02Count}  <br />  `
              violationCount++
            }

            if (trip.Violation03Count > 0) {
              desc += `Harsh Accel:  ${trip.Violation03Count}  <br /> `
              violationCount++
            }

            if (trip.Violation04Count > 0) {
              desc += `Harsh Left:  ${trip.Violation04Count}  <br /> `
              violationCount++
            }

            if (trip.Violation05Count > 0) {
              desc += `Harsh Right:  ${trip.Violation05Count}  <br />  `
              violationCount++
            }

            if (trip.Violation06Count > 0) {
              desc += `Harsh Bump:  ${trip.Violation06Count}  <br />  `
              violationCount++
            }

            if (trip.Violation07Count > 0) {
              desc += `Harsh Turn:  ${trip.Violation07Count}  <br />  `
              violationCount++
            }

            if (trip.Violation09Count > 0) {
              desc += `Accident:  ${trip.Violation09Count}  <br />  `
              violationCount++
            }

            if (trip.Violation13Count > 0) {
              desc += `RPM:  ${trip.Violation13Count}  <br /> `
              violationCount++
            }

            if (trip.Violation14Count > 0) {
              desc += `Over Speed:  ${trip.Violation14Count}  <br />  `
              violationCount++
            }

            if (violationCount > 0) {
              eventColor = 'orange'
              desc = `${str} - ${end}  <br /> ` + desc
            } else {
              eventColor = 'blue'
              desc = `${str} - ${end}` + desc
            }

            if (trip.Busy) {
              eventColor = 'green'
            }

            events.push({
              name: str,
              start: trip.StartTime.split('.')[0],
              end: trip.EndTime.split('.')[0],
              color: eventColor,
              timed: false,
              description: desc,
              Id: trip.Id,
              dayDate: this.dayDateFormat(trip.StartTime)
            })
          } catch (e1) {
            console.log(e1)
          }
        }

        return events
      } catch (e) {
        console.log(e)
        debugger
      }
    }
  }
}
</script>

<style>
  .theme--light.v-btn.v-btn--has-bg {
    background-color: rgb(71 151 255) !important;
  }
</style>
